


































import { defineComponent, ref, computed } from '@vue/composition-api'
import moment from 'moment'

import { VALID_DAYS } from '../../utils/constants'

moment.locale('ja', {
  weekdays: [
    '日曜日',
    '月曜日',
    '火曜日',
    '水曜日',
    '木曜日',
    '金曜日',
    '土曜日',
  ],
  weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
})

type Props = {
  dateTime: Date | null
  importedAt: Date | undefined
}

export default defineComponent({
  name: 'DatePicker',
  props: {
    dateTime: {
      type: Date,
      default: moment()
        .startOf('minute')
        .toDate(),
    },
    importedAt: {
      type: String,
      default: null,
    },
  },
  setup(props: Props, context) {
    const openMenu = ref(false)
    const translatedDate = computed(() =>
      props.dateTime === null
        ? ''
        : moment(props.dateTime).format('YYYY年MM月DD日(ddd)'),
    )
    const onSelectDay = (date: string) => {
      context.emit('update-date-time', moment(date).toDate())
      openMenu.value = false
    }

    const formatForDatePicker = (dateTime: Date | null) => {
      if (dateTime === null) {
        return moment()
          .startOf('minute')
          .format('YYYY-MM-DD')
      }
      return moment(dateTime).format('YYYY-MM-DD')
    }

    const allowedDate = (date: Date): boolean => {
      const target = moment(date).startOf('day')
      const today = moment().startOf('day')
      if (target.isAfter(today, 'day')) {
        // 未来のレシート日時を指定
        return false
      }
      if (props.importedAt) {
        const importedMoment = moment(props.importedAt)
        if (importedMoment.diff(target, 'day') > VALID_DAYS) {
          // レシート日時 ~ 受取日 が5日以上経過
          return false
        }
      }
      return true
    }

    return {
      openMenu,
      translatedDate,
      onSelectDay,
      formatForDatePicker,
      allowedDate,
    }
  },
})
